// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import { MessageEventKind } from "../../../define/MessageEventKind";
import { SuperPowerKind } from "../../../define/SuperPowerKind";
import NormalGameManager from "../../manager/NormalGameManager";
import UserDataManage from "../../model/UserDataManage";
import { MysticalHoleMansion } from "../kaogu/kaogu/config/kaoguDataHelp";
import { OilFieldCollect } from "../oilfield/config/oilfieldDataHelp";

const {ccclass, property} = cc._decorator;

@ccclass
export default class GMLayer extends BasePopUpLayer {

    @property(cc.Node)
    nodeHitCowClose: cc.Node = null;
    @property(cc.Node)
    nodeHitCowOpen: cc.Node = null;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.initLayer();
    }

    initLayer() {
        this.refreshHitCowState();
    }

    refreshHitCowState() {
        let bShow = UserDataManage.instance.debugData.bHitCowDebug;
        this.nodeHitCowClose.active = !bShow;
        this.nodeHitCowOpen.active = bShow;
    }

    onClickColletNvWa() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let gameData = NormalGameManager._instance.getGameData();
        gameData.nvWaStore = new Array(5).fill(true);
        NormalGameManager._instance.writeGameData();
        O1HD.getModules().uiControlModule.showMessageBox('收集成功');
    }

    onClickColletMap() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        let gameData = NormalGameManager._instance.getGameData();
        gameData.treasureMap = new Array(5).fill(true);
        NormalGameManager._instance.writeGameData();
        O1HD.getModules().uiControlModule.showMessageBox('收集成功');
    }

    onClickColletSuperPower() {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        for (let o of SuperPowerKind.SuperPowerPropList) {
            NormalGameManager._instance.onPushGoods(o, 1, false);
        }
        O1HD.getModules().uiControlModule.showMessageBox('收集成功');
    }

    onClickColletSpecialDF() {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        for (let o of MysticalHoleMansion) {
            NormalGameManager._instance.onPushGoods(o, 1, false);
        }
        O1HD.getModules().uiControlModule.showMessageBox('收集成功');
    }

    onClickShowSuperPower() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        NormalGameManager._instance.setGameData({bShowSuperPowerBtn: true});

        O1HD.emit(MessageEventKind.EventName.REFRESH_SPECIAL_BTN_STATE);
        O1HD.getModules().uiControlModule.showMessageBox('设置成功');
    }

    onClickShowKongTong() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        NormalGameManager._instance.setGameData({bShowKongTongBtn: true});

        O1HD.emit(MessageEventKind.EventName.REFRESH_SPECIAL_BTN_STATE);
        O1HD.getModules().uiControlModule.showMessageBox('设置成功');
    }


    onClickHitCow() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        UserDataManage.instance.debugData.bHitCowDebug = !UserDataManage.instance.debugData.bHitCowDebug;
        this.refreshHitCowState();
    }

    onClickHelpWife1() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let gameData = NormalGameManager._instance.getGameData();
        gameData.bOpenHitRobEvent = true;
        gameData.bFinishBoastGuiFei = true;
        gameData.bFinishHitRob = false;
        NormalGameManager._instance.writeGameData();
        O1HD.getModules().uiControlModule.showMessageBox('设置成功');
    }

    onClickHelpWife2() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let gameData = NormalGameManager._instance.getGameData();
        gameData.bFinishHelpWife = false;
        gameData.bFinishHitRob = true;
        NormalGameManager._instance.writeGameData();
        O1HD.getModules().uiControlModule.showMessageBox('设置成功');
    }

    onClickAddCoin() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        O1HD.getServices().userSrv.setCoins(100000000, true);
    }

    onClickAddDay() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        NormalGameManager._instance.setGameHours(24 * 60, true);
    }

    onClickColletKongTongJing() {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        for (let o of OilFieldCollect) {
            NormalGameManager._instance.onPushGoods(o, 1, false);
        }
        O1HD.getModules().uiControlModule.showMessageBox('收集成功');
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
    }
    

    // update (dt) {}
}
